import { type FC, type MouseEventHandler } from 'react';
import { Trans } from 'react-i18next';

import { AnimatedButton } from './styles';

type PlayInAppButtonProps = {
	onClick: MouseEventHandler;
	variant?: 'contained' | 'outlined' | 'text';
	fullWidth?: boolean;
	size?: 'small' | 'medium' | 'large';
	className?: string;
};

// Unified, animated call-to-action that opens the "download / play in app" QR modal.
export const PlayInAppButton: FC<PlayInAppButtonProps> = ({
	onClick,
	variant = 'contained',
	fullWidth = false,
	size = 'medium',
	className,
}) => (
	<AnimatedButton
		variant={variant}
		color='buttonBlue'
		size={size}
		fullWidth={fullWidth}
		onClick={onClick}
		className={className}
	>
		<Trans i18nKey='general.playInApp' />
	</AnimatedButton>
);
